<template>
  <div class="image-card-box" :style="{ backgroundImage: backgroundImage, maxWidth: maxWidth }">
    <template v-if="title || text">
      <div class="image-content" >
        <div v-if="title" class="image-title">
          {{ title }}
        </div>
        <div v-if="text" class="image-text">
          {{ text }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SquelImage',
  props: {
    imageName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    routeFile: {
      type: String,
      default: ''
    },
    baseLocation: {
      type: String,
      default: 'static/img'
    },
    maxWidth: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    backgroundImage () {
      if (!this.routeFile) {
        return `url('${this.baseLocation}/${this.imageName}')`
      }
      return `url('${this.baseLocation}/${this.routeFile}/${this.imageName}')`
    }
  }
}
</script>

<style scoped lang="scss">
.image-card-box {
  width: 100%;
  padding-top: 100%; // maintain 1:1 aspect ratio
  border-radius: 14px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
  overflow: hidden;
}

.image-content {
  position: absolute;
  top: 55%;
  display: inline-flex;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(124, 199, 205, 0.14) 0%, #FFF 100%);
  width: 100%;
  padding: 20px 20px 20% 20px;
}

.image-title {
  color: #1F2754;
  font-feature-settings: 'liga' off, 'clig' off;
  text-shadow: 0px 0px 4.877px #FFF;
  font-size: 34.14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.image-text {
  color: #536071;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Prompt;
  font-size: 21.947px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

</style>


// WEBPACK FOOTER //
// src/components/materials/SquareImage.vue